import { Login } from '@k-mille/ui-login'
import References from './references'

export default [
  Login,
  References,
]
